'use strict'

const isEmpty_ = require('lodash/isEmpty')

const convertValueToString = require('../helpers/convertValueToString')
const getFieldValue = require('../helpers/getFieldValue')

module.exports = ({ getFieldType, getSchema, wixDataProxy }) => {
  const createOption = (record, { value }) => ({
    value: convertValueToString(getFieldValue(record, value.fieldName)),
    label: convertValueToString(getFieldValue(record, value.fieldName)) || ''
  })

  const createOptionForReference = (record, displayField, fieldName) => ({
    value: JSON.stringify({ id: record._id, field: fieldName }),
    label: convertValueToString(record[displayField])
  })

  const getDropdownOptions = async (properties, actions) => {
    const isReference = getFieldType(properties.value.fieldName) === 'reference'
    if (isReference) {
      const schema = getSchema()
      const refCollection =
        schema.fields[properties.value.fieldName].referencedCollection
      const refSchema = getSchema(refCollection)
      const displayField = refSchema.displayField
      const { items } = await actions.fetchAll(properties.value.fieldName)
      return items.map(record =>
        createOptionForReference(
          record,
          displayField,
          properties.value.fieldName
        )
      )
    } else {
      const { items } = await actions.fetchAll()
      return items.map(record => createOption(record, properties))
    }
  }

  const updateComponent = async (
    { connectionConfig: { properties }, component: dropdown },
    actions
  ) => {
    if (!('value' in properties)) {
      return
    }

    const options = await getDropdownOptions(properties, actions)
    dropdown.options = options
  }

  return {
    isValidContext({ connectionConfig: { properties } }) {
      return !isEmpty_(properties)
    },

    bindToComponent({ component: dropdown }, actions) {},

    currentRecordModified: updateComponent,

    recordSetLoaded: updateComponent,

    currentViewChanged(componentAdapterContext, actions) {},

    currentIndexChanged({ component: dropdown }, actions) {}
  }
}



// WEBPACK FOOTER //
// ./adapters/dropdownOptionsAdapter.js